import React from "react";
import { LogoContainer } from "./style";
import { withRouter, NavLink } from "react-router-dom";

const Logo = props => {
  function getLogoImage() {
    return (
      <div className="logo-image">
        <img src="/images/logo.svg" alt="tankhahgardan" />
      </div>
    );
  }

  function getLogoTitle() {
    return (
      <div className="title">
        <div>تنخـواه‌گـردان</div>
        <div>ثبت مخارج و مدیریت تنخواه</div>
      </div>
    );
  }

  if (props.onClick) {
    return (
      <LogoContainer onClick={() => props.onClick()}>
        <div className="logo-mapsa-container">
          {getLogoImage()}
          {getLogoTitle()}
        </div>
      </LogoContainer>
    );
  } else {
    return (
      <LogoContainer>
        <NavLink className="logo-mapsa-container" to="/">
          {getLogoImage()}
          {getLogoTitle()}
        </NavLink>
      </LogoContainer>
    );
  }
};

export default withRouter(Logo);
